module.exports = __webpack_public_path__ + "img/ss-3.926beb96.svg";